<template>
  <div class="layer-modal"
    @click.self="closeLayer">
    <div class="toast group_layer">
      <p>{{ $t('diagnostics.enterNewGroupName') }}</p>
      <div class="input--wrap">
        <input type="text" name="" title="new group name"
        maxlength="50"
        v-model.trim="model.name"
        @keyup.enter="onAddClick" />
        <br /><strong class="wrong"
          v-if="errors.name">* {{ $t(errors.name) }}</strong>
      </div>
      <button type="button" class="btn_2 "
              @click="onAddClick">{{ $t('common.save') }}</button>
      <button @click.self="closeLayer" class="close_layer"></button>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapMutations, mapActions } from 'vuex'
import reportGroupApi from '../../../api/report-group'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'AddGroupLayer',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      errors: {},
      model: {
        name: null
      }
    }
  },
  methods: {
    ...mapMutations(['setShowReportGroupAddLayer']),
    ...mapActions(['fetchReportGroups']),
    onAddClick () {
      reportGroupApi.add(this.model).then(page => {
        if (page) {
          this.fetchReportGroups().then(this.closeLayer)
        }
      }).catch(this.handleAjaxError)
    },
    closeLayer () {
      this.setShowReportGroupAddLayer(false)
    }
  }
}
</script>

<style>
.toast {
  position: fixed;
  top: 200px;
  min-width: 300px;
  padding: 40px;
  text-align: center;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}

.toast p {
  padding-top: 20px;
}

.toast p:first-child {
  padding: 0;
}

.toast .input--wrap {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.toast .input--wrap input {
  width: 100%;
  margin-top: 10px;
}

.toast .input--wrap strong {
  display: inline-block;
  margin: 10px 0;
}

.toast.group_layer button:not(.close_layer) {
  height: 34px;
  line-height: 34px;
  margin-top: 20px;
}

.toast .wrong {
  font-size: 11px;
  color: #ff0000;
}

button.close_layer {
  background-image: url("../../../assets/images/ico_close.png");
  background-size: contain;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  top: 15px;
  right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/dashboard/AddGroupLayer.vue